export default import.meta.ROLLDOWN_FILE_URL_d0xvP7jg7ArOC$z07Bjxkg